export type GenreDetail = {
  name: string;
  en: string;
  count: string;
  intro: string;
  keywords: string[];
  tip: string;
};

export const genreDetails: GenreDetail[] = [
  {
    name: '科幻',
    en: 'Sci-Fi',
    count: '1,860 部',
    intro: '从硬核太空歌剧到近未来寓言，科幻专区收录了大量高码率的蓝光原盘资源。无论是视觉特效大片还是低成本概念佳作，都能找到匹配的高清版本，适合投影或大屏设备观看。',
    keywords: ['太空', '人工智能', '时间旅行', '赛博朋克', '末日废土'],
    tip: '建议选择 4K 蓝光原盘格式，HDR 效果在大屏上差异明显。',
  },
  {
    name: '动作',
    en: 'Action',
    count: '2,340 部',
    intro: '动作专区以近年院线大片的蓝光版本为主，动作场面多采用高帧率与无损音轨封装。片源附带多语言字幕，追车、格斗、军事等细分题材一应俱全。',
    keywords: ['格斗', '追车', '枪战', '军事', '谍战'],
    tip: '此类影片码率高、体积大，下载前请留意剩余磁盘空间。',
  },
  {
    name: '剧情',
    en: 'Drama',
    count: '3,120 部',
    intro: '剧情片专区偏向节奏舒缓、注重表演与文本的作品，包含大量三大电影节获奖或入围影片。片源多为修复版蓝光，画质与原始胶片质感兼顾。',
    keywords: ['家庭', '成长', '现实主义', '文艺', '传记'],
    tip: '部分老片为修复版，画幅与原始公映版本可能略有差异。',
  },
  {
    name: '悬疑',
    en: 'Mystery',
    count: '1,420 部',
    intro: '悬疑专区聚焦推理、犯罪与心理惊悚题材，收录了大量口碑剧集和限定剧的完整蓝光套装。字幕质量经过校对，方便观众专注梳理线索与伏笔。',
    keywords: ['推理', '犯罪', '心理惊悚', '反转', '刑侦'],
    tip: '剧集类资源多为整合套装，单集文件命名规范，便于顺序播放。',
  },
  {
    name: '历史',
    en: 'History',
    count: '980 部',
    intro: '历史与古装专区以考据严谨的时代剧和纪录片见长，服化道与场景细节丰富。资源多为高码率蓝光，适合逐帧欣赏美术与光影布置。',
    keywords: ['古装', '战争史诗', '人物传记', '王朝', '纪录片'],
    tip: '纪录片类资源常附导演解说音轨，可在播放器中切换收听。',
  },
  {
    name: '动画',
    en: 'Animation',
    count: '1,150 部',
    intro: '动画专区涵盖剧场版、合家欢与艺术短片，画质从高清到 4K 蓝光均有覆盖。多数资源保留了原始日语音轨，并提供简繁双语字幕。',
    keywords: ['剧场版', '手绘', '合家欢', '艺术短片', '童年'],
    tip: '合家欢题材建议选择内嵌软字幕版本，方便在不同设备播放。',
  },
  {
    name: '喜剧',
    en: 'Comedy',
    count: '1,260 部',
    intro: '喜剧专区以轻松解压为选片标准，收录院线喜剧、情景剧与经典老片。片源体积普遍较小，适合日常消遣与移动设备离线观看。',
    keywords: ['情景喜剧', '公路喜剧', '贺岁', '治愈', '爆梗'],
    tip: '移动端观看可选 HD 高清格式，下载更快、占用更小。',
  },
  {
    name: '爱情',
    en: 'Romance',
    count: '1,530 部',
    intro: '爱情专区收录了大量经典文艺爱情片与近年都市情感佳作，画面多为柔和的胶片色调。片源附多国字幕，适合安静夜晚独自或结伴观看。',
    keywords: ['都市情感', '文艺', '青春', '经典', '浪漫'],
    tip: '经典老片建议优先选择修复版，色调与清晰度更接近原始。',
  },
];

export type Collection = {
  title: string;
  subtitle: string;
  count: string;
  desc: string;
  tags: string[];
  cover: string;
};

export const collections: Collection[] = [
  {
    title: '2025 新片蓝光抢先看',
    subtitle: '每月更新 · 持续补充',
    count: '42 部',
    desc: '汇总本年度院线新片的蓝光与 4K 版本，按上映时间排序，方便一次性补齐进度。',
    tags: ['4K 原盘', '新片速递', '多字幕'],
    cover: 'https://readdy.ai/api/search-image?query=stylized%20cinematic%20collage%20illustration%20of%20stacked%20blu-ray%20cases%20and%20film%20reels%20glowing%20under%20warm%20projector%20light%2C%20deep%20crimson%20and%20amber%20color%20grading%2C%20dark%20background%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20high%20detail&width=800&height=560&seq=collection-2025-bluray&orientation=landscape',
  },
  {
    title: '深夜悬疑与犯罪精选',
    subtitle: '编辑亲自挑选',
    count: '28 部',
    desc: '从经典本格推理到现代心理惊悚，按“解谜难度”重新排序，适合连贯通宵刷片。',
    tags: ['推理', '反转', '剧集套装'],
    cover: 'https://readdy.ai/api/search-image?query=stylized%20moody%20illustration%20of%20a%20dusty%20desk%20with%20magnifying%20glass%2C%20old%20case%20files%20and%20a%20single%20warm%20lamp%2C%20deep%20shadows%2C%20amber%20and%20crimson%20tones%2C%20dark%20background%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20high%20detail&width=800&height=560&seq=collection-mystery-night&orientation=landscape',
  },
  {
    title: '周末合家欢片单',
    subtitle: '适合全家观看',
    count: '36 部',
    desc: '温情动画、家庭喜剧与治愈剧情混排，画面明亮、节奏轻快，适合周末亲子时光。',
    tags: ['动画', '治愈', '全年龄'],
    cover: 'https://readdy.ai/api/search-image?query=stylized%20warm%20illustration%20of%20a%20cozy%20living%20room%20movie%20night%20with%20popcorn%2C%20soft%20blanket%20and%20glowing%20screen%20light%2C%20amber%20and%20gentle%20crimson%20tones%2C%20dark%20cozy%20background%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20high%20detail&width=800&height=560&seq=collection-family-weekend&orientation=landscape',
  },
];

export type BlurayFeature = {
  icon: string;
  title: string;
  desc: string;
};

export const blurayFeatures: BlurayFeature[] = [
  {
    icon: 'ri-disc-line',
    title: '蓝光原盘直压',
    desc: '保留原始封装结构与章节信息，画质与音轨无损，画面细节与影院版本一致。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '迅雷 / 磁力高速',
    desc: '资源附带磁力链接与迅雷专用地址，热门影片节点充足，离线加速通常较快。',
  },
  {
    icon: 'ri-closed-captioning-line',
    title: '多语言字幕可选',
    desc: '常见资源内嵌简繁双语与英文软字幕，播放器内即可自由切换与开关。',
  },
  {
    icon: 'ri-hard-drive-2-line',
    title: '规格清晰标注',
    desc: '每部影片都标注分辨率、码率与体积，下载前即可判断是否适合自己的设备。',
  },
];

export type FormatRow = {
  format: string;
  resolution: string;
  sizePerHour: string;
  scene: string;
};

export const formatRows: FormatRow[] = [
  { format: '4K 蓝光原盘', resolution: '3840×2160', sizePerHour: '约 8–12 GB', scene: '家庭影院 / 投影' },
  { format: '1080P 蓝光', resolution: '1920×1080', sizePerHour: '约 3–5 GB', scene: '大屏电视 / 电脑' },
  { format: '720P HD 高清', resolution: '1280×720', sizePerHour: '约 1–2 GB', scene: '笔记本 / 平板' },
  { format: '移动端适配版', resolution: '960×540', sizePerHour: '约 0.5–1 GB', scene: '手机 / 离线缓存' },
];

export type GuideStep = {
  step: string;
  icon: string;
  title: string;
  desc: string;
};

export const guideSteps: GuideStep[] = [
  {
    step: '01',
    icon: 'ri-search-eye-line',
    title: '检索与筛选',
    desc: '在顶部搜索框输入片名、导演或主演，或直接用题材标签快速缩小范围。结果实时显示，无需跳转页面。',
  },
  {
    step: '02',
    icon: 'ri-file-list-3-line',
    title: '核对规格',
    desc: '在影片卡片上确认分辨率、码率与体积，结合自己的硬盘空间与播放设备，选择最合适的清晰度版本。',
  },
  {
    step: '03',
    icon: 'ri-link',
    title: '获取下载方式',
    desc: '常见资源提供磁力链接与迅雷地址两种方式，按需复制到下载工具即可，热门影片通常节点较多、速度稳定。',
  },
  {
    step: '04',
    icon: 'ri-play-circle-line',
    title: '校验与播放',
    desc: '下载完成后建议校验文件完整性；使用支持蓝光结构的本地播放器打开，可获得最佳画质与字幕体验。',
  },
];

export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: '站内的资源多久更新一次？',
    a: '最新上线分区通常每日更新，院线新片的蓝光版本会在发售后尽快补充；蓝光专区和排行榜每周整体刷新一次，确保排序反映近期热度。',
  },
  {
    q: '4K 蓝光和 1080P 蓝光该怎么选？',
    a: '如果使用投影或大尺寸电视，建议选择 4K 蓝光原盘；普通电脑屏幕或移动设备观看，1080P 或 720P 版本体积更小、画质已很清晰，性价比更高。',
  },
  {
    q: '迅雷链接和磁力链接有什么区别？',
    a: '磁力链接通用性更强，各类下载工具都能识别；迅雷链接针对迅雷做了优化，热门资源的加速与断点续传体验通常更好。两种方式的文件内容一致，可按习惯选择。',
  },
  {
    q: '下载后播放出现字幕不同步怎么办？',
    a: '多数资源为软字幕，可在播放器内手动微调延迟；若字幕为独立文件，请确保字幕文件名与视频文件同名并放在同一目录下，播放器即可自动加载。',
  },
  {
    q: '为什么有些影片标注了多个版本？',
    a: '同一部影片可能同时提供 4K 原盘、1080P 蓝光和移动端适配版，方便不同设备和网络条件的观众选择。卡片上会清楚标注规格，下载前请留意体积差异。',
  },
  {
    q: '排行榜的排序依据是什么？',
    a: '排行榜综合下载热度、评价人数与近期更新情况动态计算，反映的是近期受关注程度，并不等同于影片质量评分，可作为找片时的参考之一。',
  },
  {
    q: '合集片单里的影片可以单独下载吗？',
    a: '可以。合集只是编辑按主题做的推荐组合，其中的每一部影片仍可在最新上线或对应题材分区中单独查找与选择。',
  },
  {
    q: '页面会收藏我的搜索记录吗？',
    a: '不会。搜索与筛选完全在本页内进行，浏览器关闭后即失效，不会上传或保存任何个人数据。',
  },
];

export type ChartItem = {
  title: string;
  meta: string;
  rating: number;
  heat: number;
  trend: 'up' | 'down' | 'flat';
};

export const chartList: ChartItem[] = [
  { title: '星海迷航', meta: '科幻 · 2025', rating: 8.7, heat: 98, trend: 'up' },
  { title: '暗夜追凶', meta: '悬疑 · 2025', rating: 8.4, heat: 95, trend: 'up' },
  { title: '山河故人录', meta: '剧情 · 2024', rating: 9.1, heat: 92, trend: 'flat' },
  { title: '龙脊行动', meta: '动作 · 2025', rating: 8.2, heat: 90, trend: 'up' },
  { title: '光年之外', meta: '科幻 · 2025', rating: 7.9, heat: 88, trend: 'down' },
  { title: '拾光纪', meta: '动画 · 2025', rating: 8.9, heat: 86, trend: 'up' },
  { title: '无声之城', meta: '悬疑 · 2024', rating: 8.6, heat: 84, trend: 'flat' },
  { title: '深海回响', meta: '冒险 · 2025', rating: 8.3, heat: 82, trend: 'up' },
  { title: '长安月明', meta: '历史 · 2024', rating: 8.8, heat: 80, trend: 'down' },
  { title: '边境迷雾', meta: '战争 · 2025', rating: 8.0, heat: 75, trend: 'up' },
];

export type QuickItem = {
  title: string;
  meta: string;
  badge: string;
};

export const newReleases: QuickItem[] = [
  { title: '拾光纪', meta: '动画 · 家庭', badge: '今日新增' },
  { title: '笑看风云', meta: '喜剧 · 剧情', badge: '今日新增' },
  { title: '星海迷航', meta: '科幻 · 冒险', badge: '4K 更新' },
  { title: '龙脊行动', meta: '动作 · 战争', badge: '4K 更新' },
  { title: '边境迷雾', meta: '战争 · 悬疑', badge: '字幕校正' },
  { title: '暗夜追凶', meta: '悬疑 · 犯罪', badge: '新增音轨' },
];

export const trendingTags: string[] = [
  '2025新片',
  '4K蓝光原盘',
  '迅雷高速',
  '磁力链接',
  '高分悬疑',
  '合家欢动画',
  '修复经典',
  '剧集套装',
  '多字幕',
  'HDR高动态',
];

export const heroStats: { value: string; label: string }[] = [
  { value: '12,800+', label: '收录影片' },
  { value: '200+', label: '每日更新' },
  { value: '3,600+', label: '蓝光资源' },
  { value: '4 种', label: '清晰度规格' },
];

export const tickerItems: string[] = [
  '今日新增 12 部蓝光资源',
  '《星海迷航》4K 原盘已更新',
  '悬疑专区新增 3 部剧集套装',
  '《拾光纪》多语言字幕上线',
  '排行榜每周五整体刷新',
  '移动端适配版批量补充完成',
];